import { useState, useEffect, useContext } from "react";
import { Ingredients, Ingredient } from "../../utils/types";
import { IngredientsGroupProps } from "../../utils/props";
import { RecipeContext } from "../../context/RecipeContext";
import { v4 as uuidv4 } from "uuid";
import { defaultIngredient, recipeTemplate } from "../../utils/templates";
import ComponentsOptionsRequests from "../requests/ComponentsOptionsRequests";
import FormLabel from "../ui/common/Label";
import { Field } from "@headlessui/react";
import { DataContext } from "../../context/DataContext";


/** Handles selected Ingredients - mutation of ingredient's array - updates parent recipe state
 * Refactor: IngredientKeys can be removed and id associated with ingredient can now be used.
 * Need to choose between using DATE or UUID
 *
 * RecipeForm -> IngredientsGroup -> ComponentsOptionsRequests
 */
function IngredientsGroup({ onIngredientInput }: IngredientsGroupProps) {
  const { requestAction, selectedRecipe } = useContext(RecipeContext);
  const [ingredients, setIngredients] = useState<Ingredients>(
    selectedRecipe.ingredients.length === 0
      ? recipeTemplate.ingredients
      : selectedRecipe.ingredients,
  );
  const [ingredientKeys, setIngredientKeys] = useState<any>([Date.now()]); // Generate unique key on first render

    // const {ingredients} = useContext(DataContext);

  /** Create unique keys array needed for children components */
  useEffect(() => {
    if (requestAction.edit) {
      setIngredientKeys((keys) => {
        return selectedRecipe.ingredients.map(() => uuidv4());
      });
    }
  }, []);

  /** Handles adding new ingredient to array of ingredients */
  function addIngredient() {
    const newKey = Date.now();
    setIngredients((prevIngredients) => [
      ...prevIngredients,
      defaultIngredient,
    ]);
    setIngredientKeys((prevKeys) => [...prevKeys, newKey]);
  }

  /** Handles removing ingredient object from array of ingredients */
  function removeIngredient(index: number) {
    setIngredients((prevIngredients) =>
      prevIngredients.filter((_, i) => i !== index),
    );

    setIngredientKeys((prevKeys) => prevKeys.filter((_, i) => i !== index));
  }

  /** Handles updates ingredient in array of ingredients */
  function updateIngredients(newIngredient: Ingredient, index: number) {
    setIngredients((prevIngredients) => {
      const newIngredients = [...prevIngredients];
      newIngredients[index] = newIngredient;
      return newIngredients;
    });
  }

  const ingredientActions = {
    add: addIngredient,
    remove: removeIngredient,
    update: updateIngredients,
  };

  /** Updates parent state of ingredients when ingredient is added to state */
  useEffect(() => {
    onIngredientInput(ingredients, "ingredients");
  }, [ingredients]);

  return (
    <Field className="h-full">
      <div id="IngredientsGroup-main" className="h-full flex flex-col">
        <FormLabel label={"Ingredients: 1 oz Tequila"} />
        <ComponentsOptionsRequests
          numOfIngredients={ingredients.length}
          ingredients={ingredients}
          ingredientKeys={ingredientKeys}
          ingredientAction={ingredientActions}
        />
      </div>
    </Field>
  );
}

export default IngredientsGroup;
